import { useLanguage } from "../i18n/LanguageContext";
import iconImg from "../assets/images/icon.jpg";
import "./Header.css";

function EmailIcon() {
  return (
    <svg
      className="topbar-icon"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg
      className="topbar-icon"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M6.62 10.79a15.053 15.053 0 0 0 6.59 6.59l2.2-2.2a1.003 1.003 0 0 1 1.01-.24c1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
    </svg>
  );
}

function WeChatIcon() {
  return (
    <svg
      className="topbar-icon topbar-wechat"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05a6.527 6.527 0 0 1-.271-1.845c0-3.62 3.425-6.556 7.652-6.556.258 0 .507.022.76.042C16.856 4.601 13.12 2.188 8.691 2.188zm-2.6 4.17c-.577 0-1.044-.467-1.044-1.044 0-.577.467-1.044 1.044-1.044.578 0 1.045.467 1.045 1.044 0 .577-.467 1.044-1.045 1.044zm5.89 0c-.577 0-1.044-.467-1.044-1.044 0-.577.467-1.044 1.044-1.044.577 0 1.044.467 1.044 1.044 0 .577-.467 1.044-1.044 1.044zm3.903 2.092c-3.783 0-6.854 2.625-6.854 5.862 0 3.238 3.071 5.863 6.854 5.863a8.18 8.18 0 0 0 2.272-.322.72.72 0 0 1 .593.08l1.534.898a.273.273 0 0 0 .142.047c.133 0 .244-.112.244-.247 0-.06-.023-.119-.038-.177l-.327-1.233a.485.485 0 0 1 .174-.547C21.048 17.716 24 15.968 24 13.312c0-3.237-3.07-5.862-6.854-5.862h-.262zm-2.143 3.261c.475 0 .86.384.86.858a.86.86 0 0 1-.86.86.86.86 0 0 1-.86-.86c0-.474.386-.858.86-.858zm4.86 0c.474 0 .858.384.858.858a.86.86 0 0 1-.858.86.86.86 0 0 1-.86-.86c0-.474.386-.858.86-.858z" />
    </svg>
  );
}

export default function Header() {
  const { t, toggleLang } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="header" role="banner">
      <div className="header-topbar">
        <div className="topbar-inner">
          <span className="topbar-item">
            <EmailIcon />
            <a href="mailto:ying.yang@daymusic.me">ying.yang@daymusic.me</a>
          </span>
          <span className="topbar-item">
            <PhoneIcon />
            <a href="tel:0433113448">0433 113 448</a>
          </span>
          <span className="topbar-item">
            <WeChatIcon />
            yang196605
          </span>
        </div>
      </div>
      <div className="header-inner">
        <div
          className="header-logo"
          onClick={() => scrollTo("hero")}
          role="link"
          tabIndex={0}
          aria-label="Day Music Studio - Home"
          onKeyDown={(e) => e.key === "Enter" && scrollTo("hero")}
        >
          <img src={iconImg} alt="Day Music Studio" className="logo-icon" />
          <span className="logo-en">Day Music</span>
          <span className="logo-cn">Studio</span>
        </div>
        <nav className="header-nav" aria-label="Main navigation">
          <button className="nav-link" onClick={() => scrollTo("courses")}>
            {t.nav.courses}
          </button>
          <button className="nav-link" onClick={() => scrollTo("teachers")}>
            {t.nav.teachers}
          </button>
          <button className="nav-link" onClick={() => scrollTo("teacher-gallery")}>
            {t.nav.teacherGallery}
          </button>
          <button className="nav-link" onClick={() => scrollTo("performance-info")}>
            {t.nav.performanceInfo}
          </button>
          <button className="nav-link" onClick={() => scrollTo("performances")}>
            {t.nav.performances}
          </button>
          <button className="nav-link" onClick={() => scrollTo("contact")}>
            {t.nav.contact}
          </button>
          <button
            className="lang-toggle"
            onClick={toggleLang}
            aria-label="Switch language"
          >
            {t.nav.language}
          </button>
        </nav>
      </div>
    </header>
  );
}
